import { USER } from "../actions/types";

const initialState = {
  user: {},
  prices: {},
  error: null,
  invoices: [],
  billings: {},
  projects: [],
  countries: [],
  workspace: {},
  creditPrices: {},
  subscription: {},
  isLoading: true,
  notifications: [],
  organizationPeople: [], // List of people in the organization
  openAiOptinPopup: false,
  isFetchingWorkspace: false, // Show loading spinner when fetching workspace Details
  openManageSeatsModal: false,
  userPrevTaskUrlAllowed: false, // Enable Feature Flag
  userAccess: { isViewer: true }, // User access level - Viewer true by default
  organizationPeopleInvited: [], // List of people invited to the organization
  usageHistory: { date: new Date(), isFetching: false, history: [] },
};

const userReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case USER.UPDATE:
      return { ...state, isLoading: payload?.error?.status === 401, error: null, ...payload };

    case USER.RESET:
      // localStorage.removeItem("workspaceId");
      return initialState;

    case USER.TOGGLE_AIOPTIN:
      return { ...state, workspace: { ...state?.workspace, ai_summary_enabled: Number(payload) } };

    case USER.UPDATE_BILLINGS:
      return { ...state, isLoading: false, billings: { ...state.billings, ...payload } };

    case USER.UPDATE_DATA:
      return { ...state, ...payload };

    case USER.UNAUTHORIZED:
      return { ...initialState, isLoading: false, error: payload };

    case USER.UPDATE_ORG_PEOPLE_WORK_MEMBERS:
      const { workspace = {}, organizationPeople = [] } = payload;
      return {
        ...state,
        organizationPeople,
        workspace: { ...state?.workspace, ...workspace },
      };

    default:
      return state;
  }
};

export default userReducer;
